import { useMemo } from 'react';
import {
	resolveCanCreateChangeOrder,
	resolveCanResendDeposit,
	resolveCanResendInvoice,
	resolveCanResendProposal,
	resolveCanSendInvoice,
	resolveCanVoidInvoice,
} from '../capabilities';

const useBidActions = (bid, { depositPaidOnJob = 0 } = {}) =>
	useMemo(() => {
		const canResend = resolveCanResendProposal(bid);
		const canInvoice = resolveCanSendInvoice(bid);
		const canDeposit = resolveCanResendDeposit(bid, { depositPaidOnJob });
		const canResendInvoice = resolveCanResendInvoice(bid);
		const canVoidInvoice = resolveCanVoidInvoice(bid);
		const canChangeOrder = resolveCanCreateChangeOrder(bid);

		return {
			canResend,
			canSendInvoice: canInvoice,
			canResendDeposit: canDeposit,
			canResendInvoice,
			canVoidInvoice,
			canCreateChangeOrder: canChangeOrder,
			hasSentProposal: canChangeOrder,
			resendBlocked: false,
			invoiceBlocked: false,
			resendDisabled: !canResend,
			invoiceDisabled: !canInvoice || canResendInvoice,
			resendDepositDisabled: !canDeposit,
			resendInvoiceDisabled: !canResendInvoice,
			voidInvoiceDisabled: !canVoidInvoice,
		};
	}, [bid, depositPaidOnJob]);

export default useBidActions;
